//---------------------
// calc skill increase
//---------------------
export default function calcSkillIncrease(parm) {
  // console.log('---------------------------------')
  // console.log('IN calcSkillIncrease')

  const kb = Number(parm.kb) || 0
  const cur_no_adjs = Number(parm.cur_no_adjs) || 0

  // console.log('kb = ', kb)
  // console.log('cur_no_adjs = ', cur_no_adjs)

  const incr = cur_no_adjs - kb + 1
  return incr
}
